function breadList() {
    

  // key는 url , value는 메뉴명
  const labelList = {
    main: "HOME",
    dashboard: "대시보드",
    userinfo: "개인정보변경",
    master: "마스터",
    master_setting: "권한설정",
    7: "Option 7",
    8: "Option 8",
  };
  const pram = window.location.href;
  const pram2 = pram.split("/").slice(3);
  const pram3 = pram2.map((el) => {
    return labelList[el];
  });
 
  return pram3
}

export default breadList;
